import { DEFAULT_SECTION_NAME } from '@experiment-management-shared/constants';
import { PanelSection } from '@experiment-management-shared/types';

export const sortTemplateSections = (sections: PanelSection[]) =>
  sections.sort((a, b) => {
    if (a.title === DEFAULT_SECTION_NAME && a.autogenerated) return -1;
    if (b.title === DEFAULT_SECTION_NAME && b.autogenerated) return 1;

    if (a.autogenerated && b.autogenerated) {
      if (a.title < b.title) return -1;
      if (a.title > b.title) return 1;
    }

    if (a.autogenerated && !b.autogenerated) return -1;
    if (b.autogenerated && !a.autogenerated) return 1;

    return 0;
  });

export const mergeTemplateSections = (
  existedSections: PanelSection[],
  newSections: PanelSection[]
): PanelSection[] => {
  const newSetionTitles = newSections.map(s => s.title);
  const sections = existedSections.filter(
    s => !newSetionTitles.includes(s.title)
  );

  newSections.forEach(s => {
    if (s.panels?.length) {
      sections.push(s);
    }
  });

  return sortTemplateSections(sections);
};
